<template>
  <section class="container">
    <div class="shopping-step3">
      <Progress :step.sync="step" />

      <!-- 訂單明細 -->
      <OrderDetail :IsReady="IsReady" :step.sync="step" :ShoppingData.sync="ShoppingData" />

      <!-- 收件人資料 -->
      <div class="shopping-step3__card">
        <h3 class="shopping-step3__title">
          <i class="el-icon-user"></i>
          {{ $t('shopping.section.recipientInfo') }}
        </h3>
        <div class="shopping-step3__info-grid">
          <div class="shopping-step3__info-item">
            <span class="shopping-step3__label">{{ $t('shopping.label.recipientName') }}</span>
            <span class="shopping-step3__value">{{ ShoppingData.orderName }}</span>
          </div>
          <div class="shopping-step3__info-item">
            <span class="shopping-step3__label">{{ $t('shopping.label.recipientPhone') }}</span>
            <span class="shopping-step3__value">{{ ShoppingData.orderPhone }}</span>
          </div>
          <div class="shopping-step3__info-item shopping-step3__info-item--full">
            <span class="shopping-step3__label">{{ $t('shopping.label.recipientAddress') }}</span>
            <span class="shopping-step3__value">
              {{ ShoppingData.orderZipCode }} {{ ShoppingData.orderCounty }}
              {{ ShoppingData.orderCity }} {{ ShoppingData.orderAddress }}
            </span>
          </div>
          <div class="shopping-step3__info-item shopping-step3__info-item--full">
            <span class="shopping-step3__label">{{ $t('shopping.label.shippingNotes') }}</span>
            <span class="shopping-step3__value">{{ ShoppingData.orderNote || '-' }}</span>
          </div>
        </div>

        <div class="shopping-step3__divider"></div>

        <!-- 付款方式 -->
        <h3 class="shopping-step3__title">
          <i class="el-icon-bank-card"></i>
          {{ $t('shopping.section.paymentMethod') }}
        </h3>
        <div class="shopping-step3__payment">
          <p class="shopping-step3__payment-name">{{ ShoppingData.orderPayModeName }}</p>
          <div v-if="ShoppingData.orderPayMode === 3" class="shopping-step3__notice">
            <i class="el-icon-warning"></i>
            <div>
              {{ $t('shopping.notice.cardReaderRequired') }}<br />
              {{ $t('shopping.notice.windowsOnly') }}
            </div>
          </div>
        </div>
        <!-- 發票資訊 -->
        <template v-if="ShoppingData.orderInvoiceType !== 0">
          <div class="shopping-step3__divider"></div>
          <h3 class="shopping-step3__title">
            <i class="el-icon-document"></i>
            {{ $t('shopping.section.invoiceInfo') }}
          </h3>
          <div class="shopping-step3__info-grid">
            <div class="shopping-step3__info-item">
              <span class="shopping-step3__label">{{ $t('shopping.label.invoice') }}</span>
              <span class="shopping-step3__value">{{ ShoppingData.orderInvoiceTypeName }}</span>
            </div>
            <div v-if="ShoppingData.orderInvoiceType === 2" class="shopping-step3__info-item">
              <span class="shopping-step3__label">{{ $t('shopping.label.mobileCarrier') }}</span>
              <span class="shopping-step3__value">{{ ShoppingData.memberInvoiceCode }}</span>
            </div>
            <div v-if="ShoppingData.orderInvoiceType === 3" class="shopping-step3__info-item">
              <span class="shopping-step3__label">{{ $t('shopping.label.taxId') }}</span>
              <span class="shopping-step3__value">{{ ShoppingData.memberInvoiceTaxId }}</span>
            </div>
            <div v-if="ShoppingData.orderInvoiceType === 3" class="shopping-step3__info-item">
              <span class="shopping-step3__label">{{ $t('shopping.label.invoiceTitle') }}</span>
              <span class="shopping-step3__value">{{ ShoppingData.memberInvoiceTitle }}</span>
            </div>
            <div v-if="ShoppingData.orderInvoiceType === 3" class="shopping-step3__info-item">
              <span class="shopping-step3__label">{{ $t('common.label.phone') }}</span>
              <span class="shopping-step3__value">{{ ShoppingData.memberInvoicePhone }}</span>
            </div>
            <div v-if="ShoppingData.orderInvoiceType === 3" class="shopping-step3__info-item">
              <span class="shopping-step3__label">{{ $t('common.label.email') }}</span>
              <span class="shopping-step3__value">{{ ShoppingData.memberInvoiceEmail }}</span>
            </div>
            <div
              v-if="ShoppingData.orderInvoiceType === 3"
              class="shopping-step3__info-item shopping-step3__info-item--full"
            >
              <span class="shopping-step3__label">{{ $t('common.label.address') }}</span>
              <span class="shopping-step3__value">
                {{ ShoppingData.memberInvoiceZipCode }}
                {{ ShoppingData.memberInvoiceCounty }}
                {{ ShoppingData.memberInvoiceCity }}
                {{ ShoppingData.memberInvoiceAddress }}
              </span>
            </div>
          </div>
        </template>
      </div>

      <!-- 使用者合約 -->
      <div class="shopping-step3__card shopping-step3__card--contract">
        <h3 class="shopping-step3__title">
          <i class="el-icon-document-checked"></i>
          {{ $t('shopping.section.termsOfUse') }}
        </h3>
        <div class="shopping-step3__contract" v-html="ContractContent" />
        <div class="shopping-step3__agreement">
          <el-checkbox
            v-model="IsAgree"
            :true-label="1"
            :false-label="0"
            class="form-radio"
          >
            {{ $t('shopping.checkbox.agreeTerms') }}
          </el-checkbox>
        </div>
      </div>

      <!-- 按鈕 -->
      <div class="shopping-step3__actions">
        <router-link
          v-if="orderId === 0"
          class="shopping-step3__button shopping-step3__button--outline"
          to="/shopping/step2"
        >
          {{ $t('common.button.prevStep') }}
        </router-link>
        <router-link
          v-else
          class="shopping-step3__button shopping-step3__button--outline"
          :to="{ name: 'Step2', params: { orderId } }"
        >
          {{ $t('common.button.prevStep') }}
        </router-link>
        <a
          href=""
          class="shopping-step3__button shopping-step3__button--primary"
            @click.prevent="next"
          >
            {{ $t('shopping.button.confirmCheckout') }}
          </a>
      </div>

      <div v-show="false" v-if="payReady" v-append="htmlCode"></div>
    </div>
  </section>
</template>

<script>
import Progress from '@/components/Shopping/Progress.vue';
import OrderDetail from '@/components/Shopping/OrderDetail.vue';
import {
  GetShoppingCart,
  PayShoppingCart,
  GetOrderCart,
  PayOrderCart,
} from '@/api/ShoppingCartApi';
import { GetNovicesByMode } from '@/api/Novices';

export default {
  components: {
    Progress,
    OrderDetail,
  },
  data() {
    return {
      orderId: 0,
      step: 2,
      ContractContent: '',
      IsAgree: 0,
      ShoppingData: {
        orderId: 0,
        shoppings: [
          {
            courseId: 0,
            courseName: '',
            courseOriPrice: 0,
            coursePrice: 0,
            classCount: 0,
            shoppingCartDetails: [
              {
                classId: 0,
                className: '',
                subjectName: '',
                teacherName: '',
              },
            ],
          },
        ],
        discountId: 0,
        discountMode: 0,
        discountName: '',
        discountCode: '',
        discountType: 0,
        discountPrice: 0,
        discountPercent: 0,
        discountMoney: 0,
        orderName: '',
        orderPhone: '',
        orderZipCode: '',
        orderAddress: '',
        orderNote: '',
        orderPayMode: 0,
        orderPayModeName: '',
      },
      IsReady: false,
      htmlCode: '',
      payReady: false,
    };
  },
  created() {
    const { orderId } = this.$route.params;
    if (orderId !== undefined) this.orderId = orderId;
    const { check } = this.$route.params;
    if (check === undefined) this.$router.replace('/');
    this.GetNovicesByMode();
    this.GetShoppingCart();
  },
  methods: {
    GetNovicesByMode() {
      const modelId = 6;
      GetNovicesByMode(modelId).then((response) => {
        if (response.data.statusCode === 0) {
          this.ContractContent = response.data.data.noviceContent;
        }
      });
    },
    GetShoppingCart() {
      let GetWay = GetShoppingCart;
      if (this.orderId !== 0) GetWay = GetOrderCart;
      GetWay(this.orderId).then((response) => {
        if (response.data.statusCode === 0) {
          this.ShoppingData = response.data.data;
          this.IsReady = true;
        }
      });
    },
    next() {
      if (this.IsAgree === 0) {
        this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('shopping.message.readAndAgreeTerms'),
        });
        return;
      }

      this._.merge(this.ShoppingData, this.OrderForm);
      let PayWay = PayShoppingCart;
      if (this.orderId !== 0) PayWay = PayOrderCart;
      PayWay(this.orderId).then((response) => {
        this.$bus.$emit('getShoppingCartCount');
        if (response.data.statusCode === 0) {
          if (response.data.data.showType === 1) {
            this.$router.push({ name: 'Finish', params: { step: 4 } });
          } else {
            this.htmlCode = response.data.data.rtnHtml;
            this.$bus.$emit('setLoading');
          }
          this.payReady = true;
        } else {
          this.$router.push({ name: 'Finish', params: { step: 3 } });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.shopping-step3 {
  &__card {
    background-color: var(--background-white);
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-lighter);
    padding: 24px;
    margin-bottom: 20px;
    box-shadow: var(--shadow-sm);

    @media (max-width: $breakpoint-sm) {
      padding: 20px 16px;
    }

    &--contract {
      margin-top: 32px;
    }
  }

  &__title {
    font-size: var(--font-size-lg);
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 24px 0;
    display: flex;
    align-items: center;
    gap: 10px;

    i {
      font-size: 22px;
      color: var(--primary-color);
    }
  }

  &__info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 32px;
    background-color: var(--background-light);
    padding: 24px;
    border-radius: var(--border-radius-base);

    @media (max-width: $breakpoint-md) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  &__info-item {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &--full {
      grid-column: 1 / -1;
    }
  }

  &__label {
    font-size: var(--font-size-sm);
    color: var(--text-secondary);
    font-weight: 600;
  }

  &__value {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    word-break: break-word;
  }

  &__divider {
    height: 1px;
    background-color: var(--border-lighter);
    margin: 32px 0;
  }

  &__payment {
    background-color: var(--background-light);
    padding: 20px 24px;
    border-radius: var(--border-radius-base);
  }

  &__payment-name {
    font-size: var(--font-size-base);
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 12px 0;
  }

  &__notice {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    background-color: rgba(232, 137, 27, 0.1);
    border-left: 4px solid var(--warning-color);
    border-radius: var(--border-radius-base);
    margin-top: 16px;

    i {
      font-size: 20px;
      color: var(--warning-color);
      flex-shrink: 0;
      margin-top: 2px;
    }

    div {
      font-size: var(--font-size-sm);
      color: var(--text-regular);
      line-height: 1.6;
    }
  }

  &__contract {
    max-height: 400px;
    overflow-y: auto;
    padding: 20px;
    background-color: var(--background-light);
    border-radius: var(--border-radius-base);
    border: 1px solid var(--border-lighter);
    margin-bottom: 20px;
    font-size: var(--font-size-sm);
    line-height: 1.8;
    color: var(--text-regular);

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: var(--background-base);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--border-base);
      border-radius: 4px;

      &:hover {
        background-color: var(--text-placeholder);
      }
    }
  }

  &__agreement {
    padding: 16px 20px;
    background-color: var(--primary-light-color);
    border-radius: var(--border-radius-base);

    /deep/ .el-checkbox {
      display: flex;
      align-items: center;
    }

    /deep/ .el-checkbox__label {
      font-size: var(--font-size-base);
      color: var(--text-primary);
      font-weight: 600;
    }

    /deep/ .el-checkbox__inner {
      border-color: var(--primary-color);
      width: 18px;
      height: 18px;

      &::after {
        border-color: var(--text-white);
      }
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 32px;

    &--single {
      justify-content: flex-end;
    }

    @media (max-width: $breakpoint-sm) {
      gap: 12px;
      margin-top: 28px;
    }

    @media (max-width: $breakpoint-xs) {
      flex-direction: column;
      margin-top: 24px;
    }
  }

  &__button {
    padding: 14px 40px;
    border-radius: var(--border-radius-base);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all var(--transition-fast);
    text-decoration: none;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 160px;

    @media (max-width: $breakpoint-sm) {
      padding: 12px 32px;
      font-size: 15px;
      min-width: 140px;
    }

    @media (max-width: $breakpoint-xs) {
      width: 100%;
      padding: 12px 24px;
      font-size: 14px;
      min-width: auto;
    }

    i {
      font-size: 16px;
    }

    &--outline {
      border: 2px solid var(--primary-darken-color);
      background-color: transparent;
      color: var(--primary-darken-color);

      &:hover {
        transform: translateY(-1px);
      }
    }

    &--primary {
      border: 2px solid var(--primary-darken-color);
      background-color: var(--primary-darken-color);
      color: var(--text-white);

      &:hover {
        transform: translateY(-1px);
      }
    }

    &:active {
      transform: translateY(0);
    }
  }

}
</style>
